module.exports = __webpack_public_path__ + "assets/85f2c63de35f4436271aae748853f9ca.png";